import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { acceptApplicationFailed, deniedApplicationFailed, deniedApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deniedApplication(action) {
  try {
    const { id, values } = action.payload;
    const url = `${BACKEND_URL}/resources/applications/${id}/deny`;
    const dataResponse = yield makeRequest(url, values, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deniedApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(dataResponse);
      yield put(deniedApplicationFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(deniedApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
